import styled from 'styled-components';
import ReactPlayer from 'react-player/youtube';

export const ReactPlayerYouTube = styled(ReactPlayer)`
  position: relative;
`;
